import { Component, OnInit } from '@angular/core';
import { RazmjestiComponent } from './razmjesti.component';

@Component({
  selector: 'app-razmjesti-datoteke-iz-vise',
  templateUrl: './razmjesti-iz-vise.component.html'
})
export class RazmjestiDatotekeIzViseComponent
  extends RazmjestiComponent
  implements OnInit
{
  override ngOnInit() {
    this.razmjestiActionName =
      'potvrdiRazmjestanjeFizickihObjekataIzViseRazine';
    this.razmjestiListName = 'razmjesti_datoteke_iz_vise_list';
    super.ngOnInit();
  }
}
